// import React from "react";
// import {
//   Card,
//   CardContent,
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableRow,
//   TableContainer,
//   Paper,
// } from "@mui/material";
// import "./TotalsData.scss";

// export default function TotalsData({
//   invoiceTranslate,
//   companiedDetails,
//   totalAmount0,
//   totalAmount8,
//   vat8,
//   totalAmount18,
//   vat18,
//   totalAmount,
//   amountPercent,
//   transactiondetails,
// }) {
//   return (
//     <div className="summary-section">
//       {/* --- Card 1: Tax Summary --- */}
//       {companiedDetails &&
//         companiedDetails.length > 0 &&
//         (companiedDetails[0].VATDeclarant != 0 ? (
//           /* --- 🧾 TABELA ME TVSH --- */
//           <Card className="summary-section__card">
//             <CardContent>
//               <TableContainer
//                 component={Paper}
//                 className="summary-section__table-container"
//               >
//                 <Table className="summary-section__table">
//                   <TableHead>
//                     <TableRow>
//                       <TableCell className="summary-section__th">
//                         {invoiceTranslate.normaTatimore}
//                       </TableCell>
//                       <TableCell align="right" className="summary-section__th">
//                         {invoiceTranslate.base}
//                       </TableCell>
//                       <TableCell align="right" className="summary-section__th">
//                         {invoiceTranslate.vat}
//                       </TableCell>
//                       <TableCell align="right" className="summary-section__th">
//                         {invoiceTranslate.total}
//                       </TableCell>
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {/* Rreshti për 0% */}
//                     <TableRow>
//                       <TableCell>{invoiceTranslate.tvshLlogaritur0}:</TableCell>
//                       <TableCell align="right">{totalAmount0} €</TableCell>
//                       <TableCell align="right">{(0).toFixed(2)} €</TableCell>
//                       <TableCell align="right">
//                         {(Number(totalAmount0) + 0).toFixed(2)} €
//                       </TableCell>
//                     </TableRow>

//                     {/* Rreshti për 8% */}
//                     <TableRow>
//                       <TableCell>{invoiceTranslate.tvshLlogaritur8}:</TableCell>
//                       <TableCell align="right">{totalAmount8} €</TableCell>
//                       <TableCell align="right">{vat8} €</TableCell>
//                       <TableCell align="right">
//                         {(Number(totalAmount8) + Number(vat8)).toFixed(2)} €
//                       </TableCell>
//                     </TableRow>

//                     {/* Rreshti për 18% */}
//                     <TableRow>
//                       <TableCell>
//                         {invoiceTranslate.tvshLlogaritur18}:
//                       </TableCell>
//                       <TableCell align="right">{totalAmount18} €</TableCell>
//                       <TableCell align="right">{vat18} €</TableCell>
//                       <TableCell align="right">
//                         {(Number(totalAmount18) + Number(vat18)).toFixed(2)} €
//                       </TableCell>
//                     </TableRow>
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             </CardContent>
//           </Card>
//         ) : (
//           /* --- 🧾 TABELA PA TVSH --- */
//           <Card className="payment-table__card">
//             <CardContent>
//               <TableContainer
//                 component={Paper}
//                 className="payment-table__container"
//               >
//                 <Table className="payment-table__table">
//                   <TableHead>
//                     <TableRow>
//                       <TableCell className="payment-table__th" align="left">
//                         {invoiceTranslate.payment}:
//                       </TableCell>
//                       <TableCell className="payment-table__th" align="right">
//                         {(transactiondetails &&
//                         transactiondetails.length > 0 &&
//                         transactiondetails[0].Total != null
//                           ? transactiondetails[0].Total
//                           : 0
//                         ).toFixed(2)}{" "}
//                         €{" "}
//                       </TableCell>
//                     </TableRow>
//                   </TableHead>
//                 </Table>
//               </TableContainer>
//             </CardContent>
//           </Card>
//         ))}

//       {/* --- Card 2: Totals --- */}
//       <Card className="totals-table__card">
//         <CardContent>
//           <TableContainer component={Paper} className="totals-table__container">
//             <Table className="totals-table__table">
//               <TableBody>
//                 <TableRow>
//                   <TableCell className="totals-table__cell-label">
//                     {invoiceTranslate.vleraPaRabat}:
//                   </TableCell>
//                   <TableCell align="right" className="totals-table__cell-value">
//                     {(Number(totalAmount) + Number(amountPercent)).toFixed(2)} €
//                   </TableCell>
//                 </TableRow>

//                 <TableRow>
//                   <TableCell className="totals-table__cell-label">
//                     {invoiceTranslate.rabat}:
//                   </TableCell>
//                   <TableCell align="right" className="totals-table__cell-value">
//                     {Number(amountPercent).toFixed(2)} €
//                   </TableCell>
//                 </TableRow>

//                 <TableRow>
//                   <TableCell className="totals-table__cell-label">
//                     {invoiceTranslate.totalNoVAT}:
//                   </TableCell>
//                   <TableCell align="right" className="totals-table__cell-value">
//                     {(
//                       (Number(totalAmount0) || 0) +
//                       (Number(totalAmount8) || 0) +
//                       (Number(totalAmount18) || 0)
//                     ).toFixed(2)}{" "}
//                     €
//                   </TableCell>
//                 </TableRow>

//                 <TableRow>
//                   <TableCell className="totals-table__cell-label">
//                     {invoiceTranslate.totalVAT}:
//                   </TableCell>
//                   <TableCell align="right" className="totals-table__cell-value">
//                     {((Number(vat8) || 0) + (Number(vat18) || 0)).toFixed(2)} €
//                   </TableCell>
//                 </TableRow>

//                 <TableRow>
//                   <TableCell className="totals-table__header">
//                     {invoiceTranslate.payment}:
//                   </TableCell>
//                   <TableCell
//                     align="right"
//                     className="totals-table__header totals-table__header--right"
//                   >
//                     {(transactiondetails &&
//                     transactiondetails.length > 0 &&
//                     transactiondetails[0].Total != null
//                       ? transactiondetails[0].Total
//                       : 0
//                     ).toFixed(2)}{" "}
//                     €{" "}
//                   </TableCell>
//                 </TableRow>
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </CardContent>
//       </Card>
//     </div>
//   );
// }
import React from "react";
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Paper,
} from "@mui/material";
import "./TotalsData.scss";

export default function TotalsData({
  invoiceTranslate,
  companiedDetails,
  totalAmount0,
  totalAmount8,
  vat8,
  totalAmount18,
  vat18,
  totalAmount,
  amountPercent,
  transactiondetails,
}) {
  const hasCompany = companiedDetails && companiedDetails.length > 0;
  const company = hasCompany ? companiedDetails[0] : null;
  const transaction = transactiondetails?.[0];

  return (
    <div className="summary-section">
      {/* --- Card 1: Tax Summary --- */}
      {company?.VATDeclarant !== 0 ? (
        <Card className="summary-section__card">
          <CardContent>
            <TableContainer className="summary-section__table-container">
              <Table className="summary-section__table">
                <TableHead>
                  <TableRow>
                    <TableCell>{invoiceTranslate.normaTatimore}</TableCell>
                    <TableCell align="right">{invoiceTranslate.base}</TableCell>
                    <TableCell align="right">{invoiceTranslate.vat}</TableCell>
                    <TableCell align="right">{invoiceTranslate.total}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>{invoiceTranslate.tvshLlogaritur0}:</TableCell>
                    <TableCell align="right">{totalAmount0} €</TableCell>
                    <TableCell align="right">0.00 €</TableCell>
                    <TableCell align="right">
                      {(Number(totalAmount0) + 0).toFixed(2)} €
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell>{invoiceTranslate.tvshLlogaritur8}:</TableCell>
                    <TableCell align="right">{totalAmount8} €</TableCell>
                    <TableCell align="right">{vat8} €</TableCell>
                    <TableCell align="right">
                      {(Number(totalAmount8) + Number(vat8)).toFixed(2)} €
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell>{invoiceTranslate.tvshLlogaritur18}:</TableCell>
                    <TableCell align="right">{totalAmount18} €</TableCell>
                    <TableCell align="right">{vat18} €</TableCell>
                    <TableCell align="right">
                      {(Number(totalAmount18) + Number(vat18)).toFixed(2)} €
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      ) : (
        <Card className="payment-table__card">
          <CardContent>
            <TableContainer className="payment-table__container">
              <Table className="payment-table__table">
                <TableHead>
                  <TableRow>
                    <TableCell align="left">{invoiceTranslate.payment}:</TableCell>
                    <TableCell align="right">
                      {(transaction?.Total || 0).toFixed(2)} €
                    </TableCell>
                  </TableRow>
                </TableHead>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      )}

      {/* --- Card 2: Totals --- */}
      <Card className="totals-table__card">
        <CardContent>
          <TableContainer className="totals-table__container">
            <Table className="totals-table__table">
              <TableBody>
                <TableRow>
                  <TableCell>{invoiceTranslate.vleraPaRabat}:</TableCell>
                  <TableCell align="right">
                    {(Number(totalAmount) + Number(amountPercent)).toFixed(2)} €
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>{invoiceTranslate.rabat}:</TableCell>
                  <TableCell align="right">
                    {Number(amountPercent).toFixed(2)} €
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>{invoiceTranslate.totalNoVAT}:</TableCell>
                  <TableCell align="right">
                    {(
                      (Number(totalAmount0) || 0) +
                      (Number(totalAmount8) || 0) +
                      (Number(totalAmount18) || 0)
                    ).toFixed(2)}{" "}
                    €
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>{invoiceTranslate.totalVAT}:</TableCell>
                  <TableCell align="right">
                    {((Number(vat8) || 0) + (Number(vat18) || 0)).toFixed(2)} €
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell className="totals-table__header">
                    {invoiceTranslate.payment}:
                  </TableCell>
                  <TableCell
                    align="right"
                    className="totals-table__header totals-table__header--right"
                  >
                    {(transaction?.Total || 0).toFixed(2)} €
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </div>
  );
}
